import CustomPopover from "@com/components/custom-popover/index.vue";
import { computed, defineComponent } from "vue";
import { filterSchemaConfig } from "@pt/views/pt-entry/components/filter-bar/filter-model";
import i18n from "@/lang";
export default defineComponent({
    components: {
        CustomPopover: CustomPopover
    },
    props: {
        model: Object
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var label = i18n.t("resourceManager.filter.fileSize");
        var popoverSchema = [
            [
                filterSchemaConfig.size_min,
                {
                    label: "-"
                },
                filterSchemaConfig.size_max,
                filterSchemaConfig.size_unit, 
            ], 
        ];
        var durationPopoverConfig = {
            width: 300
        };
        var durationSelectedValue = computed(function() {
            var min = props.model.size_min;
            var max = props.model.size_max;
            var unit = props.model.size_unit;
            var value = "";
            if (min || max) {
                if (min) {
                    value = "".concat(min).concat(unit, "\u2264") + value;
                }
                value += i18n.t("resourceManager.filter.searchSize");
                if (max) {
                    value = value + "\u2264".concat(max).concat(unit);
                }
                return [
                    {
                        label: value,
                        value: "size"
                    }, 
                ];
            }
            return [];
        });
        var handleChange = function(value) {
            emit("change", value);
        };
        var clearValue = [
            {
                prop: "size_min",
                value: 0
            },
            {
                prop: "size_max",
                value: 0
            },
            {
                prop: "size_unit",
                value: "KB"
            }, 
        ];
        var deleteTag = function(tag) {
            emit("change", clearValue);
        };
        var handleClearClick = function(event) {
            emit("change", clearValue);
        };
        return {
            label: label,
            durationPopoverConfig: durationPopoverConfig,
            popoverSchema: popoverSchema,
            durationSelectedValue: durationSelectedValue,
            handleChange: handleChange,
            deleteTag: deleteTag,
            handleClearClick: handleClearClick
        };
    }
});
